import { AxiosPromise } from 'axios';

import AppStorage from '../../Storage/Storage';
import Requests from '../Requests';
import FinalizeHealthDeclaration from '../../interfaces/FinalizeHealthDeclaration';
import HealthDeclaration from '../../interfaces/HealthDeclaration';
import PersonalDataForm from '../../interfaces/PersonalDataForm';
import { isBrand } from '../../utils/utils';
import Brand from '../../enums/Brand';

export default class FinalizeService {
  private readonly storage: AppStorage;

  constructor() {
    this.storage = AppStorage.getInstance();
  }

  getFinalizeRequestDto = (): FinalizeHealthDeclaration => {
    const personalDataForm = this.storage.getPersonalDataFormState as PersonalDataForm;
    const phoneNumber = `${personalDataForm.phonePrefix}${personalDataForm.phoneNumberBody}`;
    const comments = this.storage.getFinalComment;
    const isWefox = isBrand(Brand.wefox);
    const gpName = personalDataForm.gpName;
    const zipCodeInt = personalDataForm.zipCodeInt;

    const zipCodeInsured = isWefox ?
      zipCodeInt :
      personalDataForm.zipCode.replaceAll(' ', '');

    return {
      remarks: comments,
      insured: {
        type: personalDataForm.type,
        phoneNumber,
        email: personalDataForm.email,
        address: {
          street: personalDataForm.street,
          city: personalDataForm.city,
          zipCode: zipCodeInsured,
          suffix: personalDataForm.suffix,
          number: personalDataForm.number,
          country: personalDataForm.country,
          type: personalDataForm.addressType,
        },
        initials: personalDataForm.initials,
        middleName: personalDataForm.middleName,
        surname: personalDataForm.surname,
        firstName: personalDataForm.firstName,
        dateOfBirth: personalDataForm.birthDate,
        gender: personalDataForm.gender,
        socialSecurityNumber: personalDataForm.socialSecurityNumber?.replace(/\s+/g, ''),
        nationality: personalDataForm.nationality,
        isSmoker: personalDataForm.isSmoker,
        occupation: personalDataForm.occupation,
      },
      generalPractitioner: {
        name: gpName,
        address: {
          city: personalDataForm.gpCity,
        },
      },
    };
  };

  finalize = (): AxiosPromise<HealthDeclaration> => {
    const dto = this.getFinalizeRequestDto();
    return Requests.finalizeHealthDeclaration(dto);
  };
}
